import { en } from "./en";

export const de: typeof en = {
  ...en,
  app: {
    ...en.app,
    sectionWorkspace: "Arbeitsbereich",
    sectionObserve: "Beobachten",
    sectionConfigure: "Konfigurieren",
    tabChat: "Chat",
    tabPlans: "Pläne",
    tabSessions: "Sitzungen",
    tabOverview: "Übersicht",
    tabUsage: "Nutzung",
    tabSystem: "System",
    tabSemantic: "Semantisch",
    tabTools: "Werkzeuge",
    tabPermissions: "Berechtigungen",
    tabMcp: "MCP",
    tabSkills: "Fertigkeiten",
    tabMemory: "Memory",
    tabHooks: "Hooks",
    tabSettings: "Einstellungen",
    sectionChanges: "Änderungen",
    tabChanges: "Änderungen",
    footer: "127.0.0.1 nur · token-gesichert",
    themeToggle: "Theme umschalten",
    themeLight: "Hell",
    themeDark: "Dunkel",
    skill: {
      ...en.app.skill,
      scope: {
        ...en.app.skill.scope,
        builtin: "Eingebaut",
        global: "Global",
        project: "Projekt",
      },
      runAs: {
        subagent: "Subagent",
        inline: "Inline",
      },
      generic: "Fertigkeit",
    },
    exportReasoningSummary: "Reasoning-Zusammenfassung",
    exportToolLabel: "Tool-Aufrufe",
    exportUserLabel: "Benutzernachrichten",
    empty: {
      ...en.app.empty,
      currentWorkspace: "Aktueller Arbeitsbereich",
      selectWorkspace: "Wähle einen Arbeitsbereich zum Starten",
      suggestion0: "Meine letzten Commit-Änderungen überprüfen",
      suggestion1: "Alle TypeScript-Fehler in der aktuellen Datei beheben",
      suggestion2: "README ins Chinesische/Englische übersetzen",
      suggestion3: "CHANGELOG für dieses Repo generieren",
      welcome: "Willkommen bei Reasonix",
    },
    errorLabel: "Fehler",
    connecting: "Verbinde…",
    session: {
      ...en.app.session,
      format: "Sitzung",
      new: "Neue Sitzung",
    },
    setup: {
      ...en.app.setup,
      choose: "Arbeitsbereich wählen",
      description: "Wähle einen Arbeitsbereich zum Starten",
      notSelected: "Kein Arbeitsbereich ausgewählt",
      saveAndStart: "Speichern & Starten",
      welcome: "Willkommen",
      workspace: "Arbeitsbereich",
    },
    tab: {
      ...en.app.tab,
      newTab: "+ Neuer Tab",
      newTabTitle: "Neuen Tab öffnen",
    },
    titlebar: {
      ...en.app.titlebar,
      clearChat: "Chat leeren",
      close: "Schließen",
      commandPalette: "Befehlsübersicht",
      contextPanel: "Kontext-Panel",
      copyMd: "Als Markdown kopieren",
      exportMd: "Als Markdown exportieren",
      maximize: "Maximieren",
      minimize: "Minimieren",
      more: "Mehr",
      restore: "Wiederherstellen",
      settings: "Einstellungen",
      sidebar: "Seitenleiste",
      windowControls: "Fenstersteuerung",
    },
    toast: {
      ...en.app.toast,
      cleared: "Chat geleert",
      copied: "In die Zwischenablage kopiert",
      copiedMd: "Als Markdown kopiert",
      emptySession: "Keine Nachrichten zum Exportieren",
      exportDialogTitle: "Chat exportieren",
      exportedMd: "Als Markdown exportiert",
      exportFailed: "Export fehlgeschlagen",
      langSwitched: "Sprache gewechselt",
      modelSwitched: "Modell → {model}",
      effortSwitched: "Effort → {effort}",
      modeSwitched: "Modus gewechselt",
      newSession: "Neue Sitzung erstellt",
    },
    yolo: {
      ...en.app.yolo,
      toast: "YOLO-Modus aktiviert",
    },
    cmd: {
      ...en.app.cmd,
      abort: "Abbrechen",
      btw: "BTW",
      clearChat: "Chat leeren",
      compact: "Komprimieren",
      copyLast: "Letzte kopieren",
      exportMd: "Als Markdown exportieren",
      feedback: "Feedback",
      help: "Hilfe",
      newSession: "Neue Sitzung",
      retry: "Erneut versuchen",
      switchModel: "Modell wechseln",
      toggleCurrency: "Währung wechseln",
      toggleLang: "Sprache wechseln",
      toggleTheme: "Theme wechseln",
    },
    header: {
      ...en.app.header,
      abort: "Abbrechen",
      clickToSelect: "Klicken zum Auswählen",
      copy: "Kopieren",
      copyMd: "Als Markdown kopieren",
      export: "Exportieren",
      exportMd: "Als Markdown exportieren",
      newChat: "Neuer Chat",
      noWorkspace: "Kein Arbeitsbereich",
      running: "Läuft…",
    },
    jumpToBottom: "Nach unten springen",
    langEN: "Englisch",
    langZH: "中文",
    splashSubtitle: "KI-gestützter Coding-Assistent",
  },
  changes: {
    ...en.changes,
    chatPlaceholder: "Frag etwas zu deinem Code...",
    chatWelcome: "Änderungen — stelle Fragen zu deinen Projektdateien.",
    chatSend: "Senden",
    viewerPlaceholder: "Wähle eine Datei zum Anzeigen",
    treeEmpty: "(leer)",
    tabClose: "Tab schließen",
    newConversation: "Neu",
    clearConversation: "Leeren",
    newTitle: "/new — Gesprächskontext löschen",
    clearTitle: "/clear — sichtbaren Scrollback leeren",
    newConfirmBusy: "Ein Turn läuft gerade. Abbrechen und neues Gespräch beginnen?",
    newConfirm: "Aktuelles Gespräch leeren und neu beginnen?",
    newToast: "neues Gespräch",
    clearToast: "Scrollback geleert",
    newFailed: "/new fehlgeschlagen: {error}",
    clearFailed: "/clear fehlgeschlagen: {error}",
    chatSendBtn: "Senden",
    fileTreeTitle: "Dateien",
    codeViewerTitle: "Code-Ansicht",
    chatPanelTitle: "Chat",
    loadingFiles: "Lade Projektdateien…",
    review: "Überprüfen",
    allFiles: "Alle Dateien",
    changes: "Änderungen",
    commentLabel: "Kommentar zu Zeile",
    commentPlaceholder: "Kommentar hinzufügen…",
    commentCancel: "Abbrechen",
    commentSubmit: "Kommentieren",
    commentLine: "Zeile",
    commentEdit: "Bearbeiten",
    commentDelete: "Löschen",
    diffSourceGit: "Git-Änderungen",
    diffSourceSession: "Vorherige Sitzung",
    diffSourceCheckpoint: "Checkpoint",
    checkpointEmpty: "Noch keine Checkpoints in diesem Arbeitsbereich.",
    restoreBtn: "Wiederherstellen",
    restoreConfirm: '"{name}" wiederherstellen? Dies überschreibt aktuelle Dateien.',
    deleteBtn: "Löschen",
    deleteConfirm: 'Checkpoint "{name}" löschen? Der Schnappschuss wird entfernt, Dateien bleiben unverändert.',
    createBtn: "Schnappschuss",
    createPlaceholder: "Name für Schnappschuss…",
    backToList: "zurück zur Liste",
    reviewEmpty: "Keine ausstehenden Überprüfungen.",
    diffStyleUnified: "Unifiziert",
    diffStyleSplit: "Geteilt",
    expandAll: "Alle erweitern",
    collapseAll: "Alle einklappen",
    createFailed: "Erstellen fehlgeschlagen",
    restoreFailed: "Wiederherstellen fehlgeschlagen",
    deleteFailed: "Löschen fehlgeschlagen",
  },
  common: {
    ...en.common,
    loading: "lade...",
    loadingFailed: "{name} fehlgeschlagen: {error}",
    back: "← zurück",
    save: "Speichern",
    remove: "entfernen",
    cancel: "Abbrechen",
    delete: "Löschen",
    add: "Hinzufügen",
    confirm: "Bestätigen",
    noData: "Noch keine {name}.",
    all: "alle",
    yes: "ja",
    no: "nein",
    on: "AN",
    off: "aus",
    enabled: "aktiviert",
    disabled: "deaktiviert",
  },
  settings: {
    ...en.settings,
    title: "Einstellungen",
    loading: "Einstellungen werden geladen...",
    saved: "gespeichert: {fields}",
    sectionApi: "DeepSeek API",
    apiKey: "API-Schlüssel",
    apiKeyNotSet: "Nicht gesetzt",
    apiKeySave: "Schlüssel speichern",
    apiKeySet: "Gesetzt",
    apiSection: "API-Konfiguration",
    notSet: "(nicht gesetzt)",
    replace: "ersetzen",
    pasteKey: "füge ein neues sk-…-Token ein",
    saveKey: "Schlüssel speichern",
    baseUrl: "Basis-URL",
    baseUrlPlaceholder: "https://api.deepseek.com (Standard)",
    baseUrlHint: "Basis-URL für API-Anfragen",
    sectionDefaults: "Standardwerte",
    effortSection: "Reasoning-Effort",
    modelCustom: "Benutzerdefinierte Modell-ID",
    modelCustomHint: "Jede OpenAI-kompatible ID, die dein Endpunkt bereitstellt (vLLM, Ollama, Together, …).",
    modelCustomActive: "Läuft aktuell auf benutzerdefinierter ID: {model}",
    appliesNextTurn: "gilt ab nächstem Turn",
    effort: "Effort",
    effortMax: "max (DeepSeek-Erweiterung — von stock OpenAI / vLLM abgelehnt)",
    effortHigh: "hoch (sicherer Standard — vLLM / Azure kompatibel)",
    effortMedium: "mittel",
    effortLow: "niedrig (am schnellsten)",
    webSearch: "Websuche",
    webSearchNote: "web_fetch + web_search Werkzeuge",
    webSearchEngine: "Suchmaschine",
    webSearchEngineBing: "bing — Standard, funktioniert von CN ohne Proxy",
    webSearchEngineSearxng: "searxng — selbst gehostet (Endpunkt via /se searxng <url>)",
    webSearchEngineMetaso: "metaso — 100/Tag kostenlos (CN-freundlich, kostenloser Schlüssel auf metaso.cn)",
    webSearchEngineTavily: "tavily — 1000/Monat kostenlos (TAVILY_API_KEY setzen)",
    webSearchEnginePerplexity: "perplexity — AI-native (PERPLEXITY_API_KEY setzen)",
    webSearchEngineExa: "exa — AI-native 1000/Monat kostenlos (EXA_API_KEY setzen)",
    webSearchEngineBrave: "brave — unabhängiger Index, 2000/Monat kostenlos (BRAVE_SEARCH_API_KEY setzen)",
    webSearchEngineOllama: "ollama — Ollama Cloud-Websuche (OLLAMA_API_KEY setzen)",
    webSearchEngineNote: "gilt für den nächsten web_search-Aufruf",
    sectionBudget: "Budget",
    budget: "Budget",
    budgetHint: "Ausgabengrenzen festlegen",
    budgetPlaceholder: "Budgetbetrag eingeben",
    budgetOf: "von",
    budgetSetCap: "Grenze setzen",
    budgetCustom: "benutzerdefiniert",
    budgetBumpHint: "Grenze erhöhen, um fortzufahren",
    budgetClear: "Grenze entfernen",
    budgetIdleLine: "warnt bei 80 % · verweigert ab 100 %",
    budgetWarnLine: "Grenze naht — Schleife wird ab 100 % verweigern",
    budgetRefusing: "Grenze erschöpft — nächster Turn verweigert bis Erhöhung oder Löschung",
    sectionLoop: "Schleife",
    loopIdleHint: "Prompt automatisch in festem Intervall erneut senden.",
    loopCostHint: "Jede Iteration kostet ~{cost} (letzter Turn).",
    loopInterval: "Intervall",
    loopCustom: "benutzerdefiniert",
    loopRangeError: "Intervall muss zwischen 5s und 6h liegen",
    loopPrompt: "Prompt",
    loopPromptPlaceholder: "z.B. überprüfe den Bereitstellungsstatus und melde Fehler",
    loopStart: "Schleife starten",
    loopStop: "Stopp",
    loopRunning: "läuft",
    loopIter: "Iteration {iter}",
    loopFiresIn: "startet in {remaining}",
    sectionSkills: "Fertigkeiten",
    skillPaths: "Skill-Pfade",
    skillPathsPlaceholder: "/pfad/zu/skills-a, /pfad/zu/skills-b",
    skillPathsNote: "kommagetrennt · nächstes /new oder neue Sitzung",
    skillsEmpty: "Keine Skills geladen",
    skillsLoaded: "Skills geladen",
    subagentModelFlash: "flash",
    subagentModelPro: "pro",
    subagentModelHint: "Modell, das verwendet wird, wenn dieser Skill seinen isolierten Subagenten startet",
    sectionRuntime: "Laufzeit",
    activeModel: "aktives Modell",
    model: "Modell",
    modelFlashDesc: "Flash — immer flash",
    modelProDesc: "Pro — immer pro",
    modelPricingLine: "${hit} Treffer · ${miss} Fehler · ${out} Ausgabe pro 1M Tokens",
    editMode: "Bearbeitungsmodus",
    editModeNote: "Umschaltung über den Chat-Tab-Header",
    editModeHint: "Bearbeitungsmodus konfigurieren",
    showSystemEvents: "Systemereignisse",
    showSystemEventsHint: "Zeige leise Inline-Hinweise zur Kontextkomprimierung, Abbruch, Ratelimit.",
    shown: "angezeigt",
    hidden: "ausgeblendet",
    sectionLanguage: "Sprache",
    language: "Sprache",
    languageHint: "Sprache wechseln",
    langEn: "English",
    langZhCn: "简体中文",
    appMode: "App-Modus",
    appearanceSection: "Darstellung",
    behaviorSection: "Verhalten",
    ruleAutoApprovalHint: "Auto-Genehmigungsregeln konfigurieren",
    ruleAutoApprovalSection: "Auto-Genehmigungsregeln",
    theme: "Theme",
    themeDark: "Dunkel",
    themeHint: "Zwischen hellem und dunklem Theme wechseln",
    themeLight: "Hell",
    themeStyle: "Theme-Stil",
    themeStyleHint: "Theme-Stil wählen",
    themeStyleGraphite: "Graphit",
    themeStyleGraphiteDesc: "Kühle dunkle Neutrale — am besten für lange Sitzungen.",
    themeStyleSandstone: "Sandstein",
    themeStyleSandstoneDesc: "Warme helle Töne — angenehm in hellen Räumen.",
    themeStylePorcelain: "Porzellan",
    themeStylePorcelainDesc: "Sauberes Hell mit extra Kontrast.",
    themeStyleMidnight: "Mitternacht",
    themeStyleMidnightDesc: "Tiefes Dunkel mit kühleren Highlights.",
    pageGeneralLabel: "Allgemein",
    pageGeneralDesc: "Theme, Schriften, Sprache und Arbeitsbereich.",
    pageModelsLabel: "Modelle",
    pageModelsDesc: "Standardmodell und Reasoning-Effort.",
    pageMcpLabel: "MCP-Server",
    pageMcpDesc: "Externe Tool-Server verbinden.",
    pageSkillsLabel: "Skills",
    pageSkillsDesc: "Benutzerdefinierte Skills, die mit /skill ausgeführt werden.",
    pageMemoryLabel: "Memory",
    pageMemoryDesc: "Langzeitnotizen, die sitzungsübergreifend mitgeführt werden.",
    pageRulesLabel: "Regeln",
    pageRulesDesc: "Auto-Genehmigungsregeln für Shell- und Pfadzugriff.",
    pageBillingLabel: "Abrechnung",
    pageBillingDesc: "API-Schlüssel, Guthaben und Sitzungsbudget.",
    pageShortcutsLabel: "Kürzel",
    pageShortcutsDesc: "Tastaturkürzel-Referenz.",
    fontFamily: "Schriftfamilie",
    fontFamilyHint: "Schriftfamilie wählen",
    fontFamilySans: "Serifenlos",
    fontFamilySerif: "Serife",
    fontFamilySystem: "System",
    fontScale: "Schriftgröße",
    fontScaleHint: "Schriftgröße anpassen",
    fontScaleLarge: "Groß",
    fontScaleMedium: "Mittel",
    fontScaleSmall: "Klein",
    currentWorkspace: "Aktueller Arbeitsbereich",
    defaultModelCurrent: "Aktuelles Modell",
    editor: "Editor",
    editorHint: "Editor-Einstellungen konfigurieren",
    maxOutput: "Max. Ausgabe",
    reasoningEffort: "Reasoning-Effort",
    reasoningEffortHint: "Reasoning-Tiefe anpassen",
    sessionCost: "Sitzungskosten",
    balanceAvailable: "Verfügbar",
    balanceLabel: "Guthaben",
    balanceLow: "Niedriges Guthaben",
    cacheHitRate: "Cache-Trefferquote",
    ctxWindow: "Kontextfenster",
    notSelected: "Nicht ausgewählt",
    parseError: "Parse-Fehler",
    workspaceChange: "Ändern",
    workspaceSection: "Arbeitsbereich",
    mcpAdd: "Hinzufügen",
    mcpAddSection: "MCP-Server hinzufügen",
    mcpBridged: "Verbunden",
    mcpConfigured: "Konfiguriert",
    mcpEmpty: "Keine MCP-Server",
    mcpNotBridged: "Nicht verbunden",
    mcpRemove: "Entfernen",
    mcpSpecFormat: "JSON-Format",
    mcpSpecLabel: "Server-Spec",
    memoryDesc: "Memory-Einstellungen konfigurieren",
    memorySection: "Memory",
    shortcutAbort: "Abbrechen",
    shortcutCloseTab: "Tab schließen",
    shortcutCommandPalette: "Befehlsübersicht",
    shortcutFocusComposer: "Composer fokussieren",
    shortcutNewChat: "Neuer Chat",
    shortcutNewTab: "Neuer Tab",
    shortcutSettings: "Einstellungen",
    shortcutSwitchTab: "Tab wechseln",
    qqAccessAllowlist: "Allowlist",
    qqAccessOpen: "Offen",
    qqAccessOwner: "Besitzer",
    qqAccessOwnerWithAllowlist: "Besitzer + Allowlist",
    qqAccessRuntime: "Laufzeit",
    qqAppId: "App-ID",
    qqApplyAction: "Anwenden",
    qqApplyLabel: "Anwenden",
    qqAppSecret: "App-Secret",
    qqBack: "Zurück",
    qqConfigure: "Konfigurieren",
    qqConfigureHint: "QQ-Integration einrichten",
    qqConfigureTitle: "QQ-Konfiguration",
    qqConnected: "Verbunden",
    qqConnecting: "Verbinde…",
    qqDisconnected: "Getrennt",
    qqEnvironment: "Umgebung",
    qqFailed: "Fehlgeschlagen",
    qqProduction: "Produktion",
    qqSandbox: "Sandbox",
    qqSave: "Speichern",
    qqSaveAndConnect: "Speichern & Verbinden",
    qqSection: "QQ-Integration",
    qqSummaryAppId: "App-ID",
    qqSummaryDetail: "Details",
    qqSummaryMissing: "Nicht konfiguriert",
    qqTitle: "QQ-Bot",
  },
  chat: {
    ...en.chat,
    modeMirror: "TUI-Spiegel",
    modeView: "Sitzungsansicht",
    placeholder: "Prompt eingeben – Enter sendet, Shift+Enter für neue Zeile · / @ für Auswahl",
    placeholderBusy: "warte auf Abschluss des aktuellen Turns…",
    placeholderSteerBusy: "tippe zum Steuern — Befehle und Auswahl sind während des Betriebs deaktiviert",
    steerHint: "Nachricht steuert den aktuellen Turn (wird als Anweisung hinzugefügt)",
    send: "Senden",
    new: "Neu",
    clear: "Leeren",
    newTitle: "/new — Gesprächskontext löschen (Schleifenlog + Scrollback)",
    clearTitle: "/clear — nur sichtbaren Scrollback leeren (Kontext bleibt)",
    noConversation: "Noch keine Unterhaltung. Sende unten einen Prompt.",
    newConfirmBusy: "Ein Turn läuft gerade. Abbrechen und neues Gespräch beginnen?",
    newConfirm: "Aktuelles Gespräch leeren und neu beginnen?",
    newToast: "neues Gespräch",
    clearToast: "Scrollback geleert",
    newFailed: "/new fehlgeschlagen: {error}",
    clearFailed: "/clear fehlgeschlagen: {error}",
    eventStreamError: "Ereignisstrom unterbrochen — verbinde neu…",
    semanticBanner: "Semantische Suche ist für dieses Projekt nicht aktiviert.",
    semanticBannerDesc:
      "Erstelle den Index einmal, und das Modell kann Code anhand der Bedeutung finden (»Wo behandeln wir Authentifizierungsfehler?«) statt nach exakten Zeichenketten zu greppen.",
    semanticBannerBtn: "Erstellen →",
    semanticBannerDismiss: "ausblenden (nicht wieder anzeigen)",
    slashCommands: "Slash-Befehle",
    projectFiles: "Projektdateien",
    effortTitle: "reasoning_effort — gilt ab nächstem Turn",
    effortMaxTitle: "max (DeepSeek-Erweiterung)",
    effortHighTitle: "hoch (sicherer Standard — vLLM / Azure kompatibel)",
    effortMediumTitle: "mittel",
    effortLowTitle: "niedrig (am schnellsten)",
    editGateTitle: "Edit-Gate — Shift+Tab schaltet in der TUI",
    editReviewTitle: "review — sowohl Edits als auch nicht-allowlistete Shell fragen zuerst",
    editAutoTitle: "auto — Edits auto-anwenden, Shell fragt weiterhin",
    editYoloTitle: "yolo — Edits UND Shell auto-ausführen, Allowlist umgangen",
    railSession: "Sitzung",
    railTurns: "Turns",
    railPromptTok: "Prompt-Tok",
    railCost: "Kosten",
    railCacheHit: "Cache-Treffer",
    railToolBudget: "Tool-Budget",
    railSpend: "Ausgaben",
    railActivePlan: "Aktiver Plan",
    railProgress: "Fortschritt",
    statusModel: "Modell",
    statusCtx: "Kontext",
    statusCache: "Cache",
    statusTurn: "Turn",
    statusSession: "Sitzung",
    statusBalance: "Guthaben",
    statusTurns: "{count} Turn{s}",
    waitingStats: "··· warte auf Live-Statistiken",
    inflightPhase: "{phase}",
    inflightRunning: "läuft",
    inflightThinking: "denkt nach",
    inflightStreaming: "streamt",
    inflightWaiting: "wartet",
    inflightReasoning: "Reasoning {count} Zch",
    inflightOut: "Ausgabe {count} Zch",
    abortBtn: "Abbrechen (Esc)",
    confirmBtn: "Anwenden (y)",
    rejectBtn: "Ablehnen (n)",
    applyRestBtn: "Rest anwenden (a)",
    flipAutoBtn: "Zu AUTO umschalten (A)",
  },
  overview: {
    ...en.overview,
    loading: "lade Übersicht…",
    failed: "Übersicht fehlgeschlagen: {error}",
    standaloneTitle: "Standalone-Modus",
    standaloneDesc:
      "Schreibgeschützte Plattenansicht. Starte /dashboard von innerhalb von reasonix code für Live-Sitzungsstatus, MCP und Tools.",
    cockpit: "Cockpit",
    balance: "Guthaben",
    tokens7d: "Tokens · 7d",
    cacheHit: "Cache-Treffer",
    toolCalls24h: "Tool-Aufrufe · 24h",
    budget: "Budget",
    currentSession: "aktuelle Sitzung",
    noSession: "Keine Live-Sitzung — /dashboard von reasonix code aus, um dich zu verbinden.",
    promptTok: "Prompt-Tok",
    completionTok: "Completion-Tok",
    cost: "Kosten",
    costTrend: "Kosten · 14 Tage",
    noUsageYet: "noch keine Nutzung",
    dayAvg: "/Tag Ø",
    recentPlans: "letzte Pläne",
    noPlans: "Noch keine Pläne — erstelle einen mit submit_plan.",
    toolActivity: "Tool-Aktivität",
    noToolCalls: "Noch keine Tool-Aufrufe.",
    toolsLoaded: "Tools geladen",
    mcpServers: "MCP-Server",
    editMode: "Bearbeitungsmodus",
    version: "Reasonix",
    workingDir: "Arbeitsverzeichnis",
    projectRoot: "Projekt-Root",
    noPriorData: "keine vorherigen Daten",
    stable: "— stabil",
    vsPrior: "{arrow} {pct}% vs. vorher",
    active: "aktiv",
    allUp: "alle betriebsbereit",
    yoloWarning: "alle Prompts umgangen",
    checking: "prüfe",
    latest: "neueste",
  },
  usage: {
    ...en.usage,
    loading: "lade Nutzung…",
    failed: "Nutzung fehlgeschlagen: {error}",
    records: "{count} Datensätze",
    dailyUsage: "Tägliche Nutzung",
    dailyMeta: "Kosten · Cache-Ersparnis · Turns",
    noData: "Noch keine Nutzungsdaten — führe einen Turn in reasonix chat / code / run aus und aktualisiere.",
    windows: "Rollierende Fenster",
    colWindow: "Fenster",
    colTurns: "Turns",
    colCacheHit: "Cache-Treffer",
    colCost: "Kosten (USD)",
    colCacheSaved: "Cache gespart",
    colVsClaude: "vs. Claude",
    colSaved: "gespart",
    axisTime: "Zeit",
    axisUsd: "USD",
    axisTurns: "Turns",
    seriesCost: "Kosten",
    seriesCacheSaved: "Cache gespart",
    seriesTurns: "Turns",
    mostUsed: "Meistgenutzte Modelle",
    colModel: "Modell",
  },
  sessions: {
    ...en.sessions,
    loading: "lade Sitzungen…",
    failed: "Sitzungen fehlgeschlagen: {error}",
    noSessions: "Noch keine gespeicherten Sitzungen.",
    filterPlaceholder: "Sitzungen filtern",
    msgs: "Nachr",
    pickHint: "Wähle links eine Sitzung, um ihr Transkript zu lesen.",
    resumeTitle: "In TUI fortsetzen",
    resumeDesc:
      "Ein Sitzungswechsel mid-Session erfordert einen Neustart, damit der Nachrichtenverlauf sauber zurückgespult werden kann. Beende deine aktuelle Sitzung und führe dann aus:",
    loadingTranscript: "lade Transkript…",
    emptyTranscript: "leeres Transkript.",
    messages: "{count} Nachricht{s}",
    newBtn: "Neue Sitzung",
    newHint: "Aktuelles Gespräch archivieren und neues beginnen",
    switchBtn: "Zu dieser Sitzung wechseln",
    deleteBtn: "Löschen",
    deleteConfirm: 'Sitzung "{name}" löschen? Dies entfernt die Transkriptdatei und kann nicht rückgängig gemacht werden.',
    cantDeleteActive: "Wechsle zu einer anderen Sitzung, bevor du diese löschst.",
    attachRequired:
      "Live-Sitzungsoperationen benötigen eine angehängte CLI-Sitzung. Starte über reasonix chat oder öffne das Dashboard von einer TUI-Sitzung aus.",
    activeChip: "aktiv",
    activePill: "aktiv",
  },
  tools: {
    ...en.tools,
    loading: "lade Tools…",
    failed: "Tools fehlgeschlagen: {error}",
    noTools: "Keine Tools registriert.",
    planMode: "Plan-Modus — Schreibzugriffe blockiert",
    colTool: "Tool",
    colFlags: "Flags",
    colDesc: "Beschreibung",
    readOnly: "schreibgeschützt",
    write: "schreiben",
    flat: "flach",
    desc: {
      ...en.tools.desc,
      web_search:
        "Durchsuche das öffentliche Web. Liefert sortierte Ergebnisse mit Titel, URL und Ausschnitt. Verwende dies, wenn die Antwort vom aktuellen Zustand abhängt — Ereignisse, Preise, Veröffentlichungen, Echtzeit-Status.",
      web_fetch:
        "Lade eine URL herunter und gib den sichtbaren Textinhalt zurück (Skripte/Styles/Navigation entfernt). Nach web_search verwenden, wenn ein Ausschnitt nicht ausreicht.",
      run_command:
        "Führe einen Shell-Befehl im Projekt-Root aus; gibt kombinierte stdout+stderr zurück. Allowlistete schreibgeschützte Befehle werden sofort ausgeführt; Änderungen benötigen Benutzerbestätigung.",
      run_background:
        "Starte einen langlebigen Prozess und trenne ihn. Liefert eine Job-ID zum Verfolgen der Logs, Warten auf Abschluss oder Beenden. Für Dev-Server, Watcher und einmalige Langzeit-Jobs.",
      job_output:
        "Lies die neueste Ausgabe eines Hintergrund-Jobs. Gibt das Ende des Puffers zurück und sagt dir, ob der Job noch läuft.",
      wait_for_job:
        "Blockiere serverseitig, bis ein Hintergrund-Job abgeschlossen ist, zeitlich begrenzt. Statt job_output in einer Schleife zu pollen.",
      stop_job:
        "Stoppe einen Hintergrund-Job. SIGTERM zuerst, SIGKILL nach einer Gnadenfrist. Sicher für bereits beendete Jobs.",
      list_jobs:
        "Liste jeden in dieser Sitzung gestarteten Hintergrund-Job auf — laufende und beendete — mit ID, Befehl, PID und Status.",
      remember:
        "Speichere eine Erinnerung für zukünftige Sitzungen. Verwende, wenn der Benutzer eine Präferenz angibt, deinen Ansatz korrigiert, eine nicht offensichtliche Tatsache teilt oder dich bittet, etwas zu merken.",
      forget:
        "Lösche eine Memory-Datei und entferne sie aus MEMORY.md. Verwende, wenn der Benutzer vergessen möchte oder eine gespeicherte Tatsache jetzt falsch ist.",
      recall_memory:
        "Lies den vollständigen Body einer Memory-Datei, wenn die einzeilige Zusammenfassung nicht genug Detail bietet.",
      read_file:
        "Lese eine Datei unter dem Sandbox-Root. Unterstützt head/tail/range-Begrenzung zum Kontextsparen. Gibt automatisch eine Vorschau für Dateien über 200 Zeilen zurück.",
      list_directory:
        "Liste Einträge in einem Verzeichnis auf. Gibt eine Zeile pro Eintrag zurück und markiert Verzeichnisse mit einem Schrägstrich.",
      directory_tree:
        "Liste Einträge in einem Verzeichnis rekursiv als eingerückten Baum auf. Budget-bewusst mit automatischem Einklappen für große Unterbäume.",
      search_files:
        "Finde Dateien, deren NAME einem Teilstring oder Regex entspricht. Groß-/Kleinschreibung unwichtig. Überspringt standardmäßig Abhängigkeits-/Build-Verzeichnisse.",
      search_content:
        "Durchsuche Dateiinhalte rekursiv mit grep nach einem Teilstring oder Regex. Liefert Treffer im Format pfad:zeile:text. Das richtige Werkzeug zum Finden von Referenzen.",
      glob: "Liste Dateien, die einem Glob-Muster entsprechen, sortiert nach Änderungsdatum. Standardlimit 200, max 1000. Überspringt node_modules/.git/dist standardmäßig.",
      get_file_info: "Ermittle Informationen zu einem Pfad unter dem Sandbox-Root. Liefert Typ, Größe in Bytes und Änderungsdatum.",
      write_file:
        "Erstelle oder überschreibe eine Datei mit dem angegebenen Inhalt. Übergeordnete Verzeichnisse werden bei Bedarf erstellt.",
      edit_file:
        "Wende eine SEARCH/REPLACE-Bearbeitung auf eine vorhandene Datei an. Die Suche muss exakt übereinstimmen und in der Datei eindeutig sein.",
      multi_edit:
        "Wende N SEARCH/REPLACE-Bearbeitungen atomar auf eine oder mehrere Dateien an. Wenn eine Bearbeitung fehlschlägt, werden keine Dateien geschrieben.",
      create_directory: "Erstelle ein Verzeichnis (und alle fehlenden übergeordneten) unter dem Sandbox-Root.",
      move_file: "Benenne eine Datei oder ein Verzeichnis unter dem Sandbox-Root um oder verschiebe es.",
      delete_file:
        "Lösche eine Datei unter dem Sandbox-Root. Lehnt Verzeichnisse ab — verwende delete_directory dafür.",
      delete_directory:
        "Lösche rekursiv ein Verzeichnis unter dem Sandbox-Root. Übergib recursive:false, um nicht-leere Verzeichnisse abzulehnen.",
      copy_file:
        "Kopiere eine Datei oder ein Verzeichnis unter dem Sandbox-Root. Lehnt das Überschreiben eines vorhandenen Ziels ab.",
      submit_plan:
        "Reiche einen konkreten Plan für ein Review-Gate ein. Für dateiübergreifende Refactorings, Architekturänderungen oder alles, was teuer rückgängig zu machen ist.",
      mark_step_complete:
        "Markiere einen Schritt des genehmigten Plans als erledigt. Genau einmal nach Abschluss jedes Schritts aufrufen.",
      revise_plan:
        "Ersetze gezielt die verbleibenden Schritte eines laufenden Plans. Erledigte Schritte werden nie berührt.",
      run_skill:
        "Rufe ein Playbook aus dem Skills-Index auf. Übergib den bloßen Skill-Namen. Subagent-gekennzeichnete Skills starten einen isolierten Subagenten.",
      spawn_subagent:
        "Starte einen isolierten Subagenten für eine in sich geschlossene Teilaufgabe. Für paralleles Fan-out oder wenn die Arbeit viele Dateilesevorgänge benötigt.",
      todo_write:
        "Aufgaben-Tracker innerhalb der Sitzung für mehrschrittige Arbeit. Ersetzt bei jedem Aufruf die gesamte Liste. Kein Genehmigungs-Gate oder Dateischreibvorgänge.",
      ask_choice:
        "Präsentiere 2–6 Alternativen dem Benutzer. Verwende, wenn der Benutzer nach Optionen fragt oder du eine Präferenzentscheidung benötigst.",
      create_skill:
        "Erstelle ein neues Skill-Gerüst, das der Benutzer später mit /skill aufrufen kann. Unterstützt Inline- und Subagent-Ausführungsmodi.",
      add_mcp_server:
        "Registriere einen neuen MCP-Server in der Konfiguration des Benutzers. Wirkt ab der nächsten Sitzung. Unterstützt stdio, SSE und streamable-http.",
    },
  },
  permissions: {
    ...en.permissions,
    loading: "lade Berechtigungen…",
    failed: "Berechtigungen fehlgeschlagen: {error}",
    yoloTitle: "YOLO-Modus",
    yoloDesc:
      "Jeder Shell-Befehl läuft automatisch, Allowlist umgangen. Zurück mit /mode review in der TUI.",
    project: "Projekt",
    builtin: "Eingebaut",
    addPrefix: "Präfix hinzufügen",
    addPlaceholder: 'z.B. "npm run build" oder "deploy.sh"',
    clearAll: "Alle löschen",
    alreadyIn: "{prefix} bereits in der Liste",
    added: "hinzugefügt: {prefix}",
    removed: "entfernt: {prefix}",
    cleared: "{count} Eintrag{Einträge} gelöscht",
    removeConfirm: '"{prefix}" aus der Allowlist dieses Projekts entfernen?',
    clearConfirm: "Alle Projekt-Allowlist-Einträge löschen? Builtin-Einträge bleiben unberührt.",
    projectAllowlist: "Projekt-Allowlist · {count}",
    nothingStored: "Noch nichts für dieses Projekt gespeichert.",
    colNum: "#",
    colPrefix: "Präfix",
    builtinTitle: "Eingebaut · {count} · schreibgeschützt",
    standaloneWarning:
      "Änderungen erfordern /dashboard von innerhalb einer aktiven reasonix code-Sitzung — das Standalone-Dashboard kann nicht erkennen, welche Projekt-Allowlist zu bearbeiten ist.",
  },
  mcp: {
    ...en.mcp,
    loading: "lade MCP…",
    servers: "MCP-Server · {count} verbunden",
    all: "alle",
    live: "live",
    unbridged: "unverbunden",
    specPlaceholder: "Spec — z.B. fs=npx -y @modelcontextprotocol/...",
    saved: "gespeichert",
    savedRestart: "gespeichert — starte reasonix code neu, um diesen Server zu verbinden",
    removed: "entfernt — starte neu, um die Live-Verbindung zu trennen",
    removeConfirm: "MCP-Spec aus Konfiguration entfernen?\n\n{spec}",
    noServers: "Keine MCP-Server in dieser Sitzung.",
    tools: "Tools",
    inConfig: "in Konfiguration · nicht geladen",
    unbridgedTitle: "unverbunden · in Konfiguration",
    removeBtn: "Entfernen",
    spec: "Spec",
    whyUnbridged: "Warum unverbunden?",
    whyUnbridgedDesc:
      "Diese Spec befindet sich in deiner config.json, ist aber nicht in die Live-Sitzung eingebunden. MCP-Server werden beim Start von reasonix code angehängt; das Dashboard allein kann den Kindprozess nicht starten.",
    whyUnbridgedHint: "Zum Aktivieren: starte reasonix code neu und aktualisiere dieses Dashboard.",
    bridgeFailed: "Verbindung fehlgeschlagen",
    bridgeFailedTitle: "Verbindung fehlgeschlagen · in Konfiguration",
    bridgeFailedHint:
      "Reasonix hat versucht, diesen Server zu verbinden, und der Versuch ist fehlgeschlagen. Häufige Ursachen: falsche URL, fehlender Auth-Header, upstream 404/5xx, fehlender lokaler Befehl. Behebe und starte reasonix code neu.",
    pickHint: "Wähle links einen MCP-Server zum Inspizieren von Tools / Ressourcen / Prompts.",
    toolsTitle: "Tools · {count}",
    resourcesTitle: "Ressourcen · {count}",
    promptsTitle: "Prompts · {count}",
    colName: "Name",
    colDesc: "Beschreibung",
    colUri: "URI",
    marketplace: "Marktplatz",
    marketplaceSearch: "Registry durchsuchen…",
    marketplaceLoading: "lade Registry…",
    marketplaceMore: "5 weitere Seiten laden",
    marketplaceMoreLabel: "50 mehr laden  ·  zeige {shown} / {total}",
    marketplaceMoreHint: "ruft weitere Seiten von der Registry ab",
    marketplaceMoreCachedHint: "weitere Einträge bereits lokal zwischengespeichert",
    marketplaceExhausted: "alle Seiten geladen",
    marketplaceExhaustedFull: "zeige alle {total} Einträge — Registry erschöpft",
    marketplaceCount: "{loaded} geladen · {matched} Treffer · Quelle: {source}{cached}",
    marketplaceCachedSuffix: " · zwischengespeichert",
    marketplaceNoMatches: "Keine Treffer. Versuche andere Begriffe oder lade mehr Seiten.",
    marketplaceInstall: "Installieren",
    marketplacePickHint: "Wähle links einen Server, dann Installieren.",
    marketplaceInstalled: "installiert → {spec}",
    marketplaceInstalledBridged: "installiert + verbunden → {spec}",
    marketplaceAlready: "bereits installiert",
    marketplaceNeedsEnv: "benötigt Umgebungsvariable: {names}",
    marketplaceSourceTag: "[{source}]",
    marketplaceNoInstall:
      "Smithery-Eintrag — Installationsmetadaten nicht verfügbar; verwende `npx -y @smithery/cli install {name}` direkt",
    marketplaceFetchOnInstall:
      "Smithery-Eintrag — Installationsdetails werden bei Install abgerufen. HTTP-Server werden als streamable-http-Remotes abgebildet; stdio-Server laufen über @smithery/cli.",
    marketplaceInstalledBadge: "installiert",
    marketplaceUninstall: "Deinstallieren",
    marketplaceEnvTitle: "Erforderliche Umgebungsvariablen",
    marketplaceEnvHint:
      "Setze diese in deiner Shell vor dem nächsten `reasonix code`, damit der verbundene Server authentifizieren kann.",
    marketplaceRestartHint:
      "Spec in ~/.reasonix/config.json geschrieben. Starte `reasonix code` neu, um den Server zu verbinden (Live-Hot-Reload ist auf der Roadmap).",
  },
  memory: {
    ...en.memory,
    loading: "lade Memory…",
    files: "Memory · {count} Dateien",
    exists: "existiert",
    create: "erstellen",
    noFiles: "Noch keine Memory-Dateien.",
    pickHint: "Wähle links eine Memory-Datei.",
    pickDesc: "Projekt-REASONIX.md ist commitierbar; globale Notizen leben in ~/.reasonix/memory/.",
    chars: "{count} Zeichen",
    saved: "{scope} gespeichert",
    reloadHint: "wird beim nächsten /new oder Sitzungsneustart neu angewendet",
  },
  hooks: {
    ...en.hooks,
    loading: "lade Hooks…",
    resolved: "aufgelöst",
    eventMatrix: "Ereignismatrix",
    matrixSub: "{scripts} Skript{s} × {events} Ereignis{se}",
    noHooks: "Keine Hooks konfiguriert. Bearbeite das JSON unten, um welche hinzuzufügen.",
    colScript: "Skript",
    noProject: "Kein aktives Projekt — öffne /dashboard von reasonix code, um Projekt-Hooks zu bearbeiten.",
    saveReload: "Speichern + Neu laden",
    discard: "Änderungen verwerfen",
    savedReloaded: "{scope} gespeichert + neu geladen",
    recentRuns: "Letzte Ausführungen",
    noRuns: "Keine Hook-Ausführungen im aktuellen Sitzungslog.",
    colWhen: "Wann",
    colPhase: "Phase",
    colHook: "Hook",
    colOutcome: "Ergebnis",
  },
  skills: {
    ...en.skills,
    loading: "lade Skills…",
    filterPlaceholder: "Skills filtern",
    project: "Projekt",
    custom: "Benutzerdefiniert",
    global: "Global",
    builtin: "Eingebaut",
    newSkill: "neuer Skill",
    noDescription: "(keine Beschreibung)",
    runs7d: "Ausführungen · 7d",
    pickHint: "Wähle links einen Skill oder erstelle oben einen neuen.",
    readOnlyBuiltin: "schreibgeschützt · eingebaut",
    readOnlyCustom: "schreibgeschützt · benutzerdefinierter Pfad",
    builtinDesc:
      "Eingebaute Skills werden mit Reasonix ausgeliefert; das Modell nimmt sie automatisch auf. Zum Anpassen erstelle einen Skill mit gleichem Namen im Projekt- oder globalen Bereich.",
    saved: "{scope}/{name} gespeichert",
    deleteConfirm: "Skill {scope}/{name} löschen?",
    reloadHint: "wird beim nächsten /new oder Sitzungsneustart neu geladen",
  },
  system: {
    ...en.system,
    loading: "lade Gesundheit…",
    failed: "Gesundheitscheck fehlgeschlagen: {error}",
    healthChecks: "Gesundheitsprüfungen",
    version: "Version",
    checking: "prüfe",
    latest: "● aktuell",
    outOfDate: "● veraltet",
    versionPending: "Versionsprüfung ausstehend",
    upToDate: "aktuell",
    latestVer: "neueste: {version}",
    sessions: "Sitzungen",
    ok: "● ok",
    memory: "Memory",
    semanticIndex: "Semantischer Index",
    built: "● erstellt",
    none: "— keine",
    runIndex: "führe reasonix index zum Erstellen aus",
    usageLog: "Nutzungslog",
    backgroundJobs: "Hintergrund-Jobs",
    noSession: "— keine Sitzung",
    running: "{count} laufend",
    attachHint: "Sitzung anhängen, um Jobs zu sehen",
    shellSpawn: "Shell + Start",
    paths: "Pfade",
    home: "Home",
    sessionsPath: "Sitzungen",
    memoryPath: "Memory",
    semanticPath: "Semantisch",
    usagePath: "Nutzung",
  },
  plans: {
    ...en.plans,
    loading: "lade Pläne…",
    failed: "Pläne fehlgeschlagen: {error}",
    noPlans: "Noch keine archivierten Pläne — führe einen Turn aus, der submit_plan und mark_step_complete aufruft.",
    filterPlaceholder: "Pläne filtern",
    active: "aktiv",
    done: "erledigt",
    idle: "inaktiv",
    steps: "Schritte",
    pickHint: "Wähle links einen Plan.",
    noTitle: "(kein Titel)",
    stepTimeline: "Schritt-Zeitleiste · {done} / {total}",
    step: "Schritt {n}",
  },
  semantic: {
    ...en.semantic,
    codeRequired: "Semantisch — Code-Modus erforderlich",
    indexBuilt: "Index erstellt",
    noIndex: "noch kein Index",
    ready: "bereit",
    setupNeeded: "Setup erforderlich",
    installOllama: "Ollama installieren",
    installOllamaDesc:
      "Reasonix führt keine Paketverwaltung für dich aus. Installiere zuerst Ollama, dann komme zurück:",
    macWindows: "macOS / Windows:",
    download: "herunterladen von ollama.com/download",
    linux: "Linux:",
    refreshHint:
      "Nach der Installation aktualisieren — dieses Panel bietet dann an, den Daemon zu starten und {model} zu ziehen.",
    daemon: "Daemon",
    daemonDesc: "Ollama ist im PATH, aber der HTTP-Daemon ist nicht erreichbar.",
    startDaemon: "Daemon starten",
    runsOllama: "führt ollama serve getrennt aus",
    model: "Modell",
    modelMissing: "{model} ist noch nicht installiert.",
    modelSize: "~270 MB beim ersten Pull.",
    pulling: "ziehe…",
    pullModel: "{model} ziehen",
    indexStatus: "Index-Status",
    builtStatus: "● erstellt",
    incompatibleStatus: "● inkompatibel",
    chunks: "Chunks",
    files: "Dateien",
    dim: "Dim",
    size: "Größe",
    lastBuild: "letzte Erstellung",
    builtWith: "erstellt mit",
    currentTarget: "aktuelles Ziel",
    incompatibleHint:
      "Dieser Index auf der Platte wurde für einen anderen Anbieter oder ein anderes Modell erstellt. Führe Neu erstellen aus, um ihn zu ersetzen.",
    runIndexHint: "Führe einen Index aus, um semantic_search zu aktivieren.",
    reIndex: "Neu indizieren",
    build: "Erstellen",
    rebuild: "Neu erstellen",
    stop: "Stopp",
    provider: "Anbieter",
    providerType: "Diensttyp",
    openaiCompat: "OpenAI-kompatibel",
    apiUrl: "API-URL",
    apiKey: "API-Schlüssel",
    apiKeyStoredNote: "API-Schlüssel wird in ~/.reasonix/config.json gespeichert — teile diese Datei nicht.",
    customRequestBody: "benutzerdefinierter Request-Body",
    invalidCustomRequestBody: "Der benutzerdefinierte Request-Body muss gültiges JSON sein: {error}",
    customRequestBodyMustBeObject: "Der benutzerdefinierte Request-Body muss ein JSON-Objekt sein.",
    saveBeforeIndex: "Speichere semantische Einstellungen vor dem Start eines Index.",
    extraBody: "zusätzlicher Body",
    batchSize: "Batch-Größe",
    keepExistingKey: "leer lassen, um vorhandenen Schlüssel zu behalten",
    remoteProvider: "Remote-Embedding-Anbieter",
    remoteProviderDesc:
      "Konfiguriere hier die vollständige OpenAI-kompatible Embeddings-URL. Reasonix sendet Anfragen genau an die von dir angegebene URL.",
    ollama: "Ollama",
    binary: "Binärdatei",
    found: "gefunden",
    missing: "fehlt",
    daemonStatus: "Daemon",
    up: "aktiv",
    down: "inaktiv",
    pulled: "gezogen",
    indexConfig: "Index-Konfiguration",
    reset: "Zurücksetzen",
    excludeDirs: "Verzeichnisse ausschließen",
    excludeFiles: "Dateien ausschließen",
    excludeExts: "Erweiterungen ausschließen",
    excludePatterns: "Muster ausschließen",
    glob: "Glob",
    respectGitignore: ".gitignore beachten",
    maxFileBytes: "max. Dateigröße",
    skipLarger: "überspringe Dateien größer als ~{size} MiB",
    preview: "Vorschau",
    searchPlaceholder: "beschreibe, was zu finden ist — »wo behandeln wir Abbruchsignale«",
    searching: "suche…",
    results: "{count} Ergebnis{se} · {ms}ms · {model}",
    noMatches: "Keine Treffer über dem Schwellenwert.",
    previewSummary: "Vorschau — würde {included} Datei(en) indizieren, {skipped} überspringen",
    nothingSkipped: "nichts übersprungen — alle durchlaufenen Dateien würden indiziert.",
    firstIncluded: "erste {count} einbezogene Datei(en)",
    job: "Job",
    phaseSetup: "Vorbereitung",
    phaseScan: "Dateien scannen",
    phaseEmbed: "Chunks einbetten",
    phaseWrite: "Index schreiben",
    phaseDone: "erledigt",
    phaseError: "Fehler",
    phaseCancelled: "abgebrochen",
    setupFailed: "Setup fehlgeschlagen",
    stopping: "stoppe",
    scanned: "{count} gescannt",
    changed: "{count} geändert",
    skipped: "{count} übersprungen",
    chunksProgress: "{done} / {total} ({pct}%)",
    result: "Ergebnis",
    added: "{count} hinzugefügt",
    removed: "{count} entfernt",
    failed: "{count} fehlgeschlagen",
    skippedFiles: "{total} Dateien ({details})",
    rebuildStarted: "Neuerstellung gestartet",
    incrementalStarted: "inkrementelle Indizierung gestartet",
    stopRequested: "Stopp angefordert — aktueller Chunk-Batch wird zuerst beendet",
    startingDaemon: "starte Ollama-Daemon (15s Timeout)…",
    daemonUp: "Daemon ist aktiv",
    daemonTimeout: "Daemon wurde nicht rechtzeitig aktiv — überprüfe ollama serve manuell",
    pullingModel: "ziehe {model} — dies kann bei der ersten Installation einige Minuten dauern",
    savedConfig: "gespeichert · {count} Felder aktualisiert · führe Index erneut aus, um anzuwenden",
    runningPreview: "führe Trockenlauf gegen Projekt-Root aus…",
    exclude: "ausschließen",
  },
  modal: {
    ...en.modal,
    shellTitle: "Shell-Befehl",
    shellBgTitle: "Hintergrundprozess",
    shellSubtitle: "Modell möchte einen Shell-Befehl ausführen",
    shellBgSubtitle: "langlebig — läuft nach Genehmigung weiter",
    pathTitle: "Datei außerhalb des Sandbox",
    pathSubtitle: "{intent} via {tool}",
    pathRead: "lesen",
    pathWrite: "schreiben",
    pathSandboxLabel: "Sandbox",
    pathAllowPrefixLabel: "Präfix erlauben",
    runOnce: "Einmal ausführen",
    alwaysAllow: '"{prefix}" immer erlauben',
    deny: "Ablehnen",
    choiceTitle: "Modell möchte, dass du wählst",
    typeOwn: "Eigene Antwort eingeben",
    typeOwnSummary: "Keine der Optionen passt — schreibe eine Freitext-Antwort.",
    typePlaceholder: "Freitext-Antwort eingeben…",
    send: "Senden",
    cancel: "Abbrechen",
    cancelSummary: "Frage verwerfen. Modell fragt, was du eigentlich möchtest.",
    planTitle: "Plan eingereicht",
    planSubtitle: "Modell hat einen Plan vorgeschlagen; überprüfe, dann wähle",
    approveInstructions:
      "Optionale letzte Anweisungen / Antworten auf offene Fragen (Enter zum Leer-Senden)",
    refinePlaceholder: "Was muss sich ändern? Sei konkret.",
    approve: "Genehmigen",
    refine: "Verfeinern",
    sendRefinement: "Verfeinerung senden",
    editTitle: "Edit ausstehend zur Überprüfung",
    editSubtitle: "{path} · {remaining} von {total} Blöcken verbleibend",
    before: "vorher",
    after: "nachher",
    workspaceTitle: "Modell möchte Arbeitsbereich wechseln",
    workspaceSubtitle: "jedes nachfolgende Datei-/Shell-/Memory-Tool wird gegen den neuen Root aufgelöst",
    switchBtn: "Wechseln (Enter)",
    denyBtn: "Ablehnen (Esc)",
    stepComplete: "Schritt abgeschlossen{counter}",
    continueBtn: "Fortsetzen",
    reviseBtn: "Überarbeiten…",
    stopBtn: "Stopp",
    revisionTitle: "Modell hat eine Planüberarbeitung vorgeschlagen",
    sendRevision: "Überarbeitung senden",
    accept: "Akzeptieren",
    reject: "Ablehnen",
    arguments: "Argumente",
    revisePlaceholder: "Was muss sich vor dem nächsten Schritt ändern? Leer lassen zum Fortfahren.",
    pickerFilter: "Filter…",
    pickerEmpty: "Nichts anzuzeigen.",
    pickerLoadMore: "Mehr laden",
    pickerPick: "Öffnen",
    pickerInstall: "Installieren",
    pickerUninstall: "Deinstallieren",
    pickerRename: "Umbenennen…",
    pickerNew: "Neu…",
    pickerNewPlaceholder: "Name (leer lassen für Standard)",
    viewerClose: "Schließen",
  },
  error: {
    ...en.error,
    title: "Etwas ist im Dashboard kaputtgegangen",
    body: "Die TUI ist nicht betroffen — nur dieser Browser-Tab ist gestolpert. Du kannst schließen und weiterarbeiten oder es melden, damit wir die Ursache beheben.",
    copyDetails: "Details kopieren",
    copied: "Kopiert ✓",
    reportOnGithub: "Auf GitHub melden",
    dismiss: "Schließen (Esc)",
    crashing: "dieses Panel stürzt ständig ab — {name}",
    retry: "Erneut versuchen",
    recovering: "wiederherstellen…",
  },
  fmt: {
    ...en.fmt,
    justNow: "gerade eben",
    minutesAgo: "vor {n}m",
    hoursAgo: "vor {n}h",
    daysAgo: "vor {n}T",
  },
  cards: {
    ...en.cards,
    applied: "Angewendet",
    cacheHit: "Cache-Treffer",
    checkpointRewind: "Checkpoint-Rückspulen",
    cost: "Kosten",
    diffApply: "Anwenden",
    diffApplyChanges: "Änderungen anwenden",
    diffAwaiting: "Wartet auf Überprüfung",
    diffDiscard: "Verwerfen",
    done: "Fertig",
    elapsed: "Verstrichen",
    error: "Fehler",
    errorName: "Fehler",
    failed: "Fehlgeschlagen",
    hits: "Treffer",
    memoryCountSuffix: "Erinnerungen",
    memoryName: "Memory",
    output: "Ausgabe",
    planDefaultTitle: "Plan",
    prompt: "Prompt",
    compactionMeta: "{chars} Zeichen",
    compactionName: "Komprimierter Verlauf",
    reasoningComplete: "Reasoning abgeschlossen",
    reasoningName: "Reasoning",
    result: "Ergebnis",
    running: "Läuft",
    searchName: "Suche",
    shellAlwaysAllow: "Immer erlauben",
    shellAwaiting: "Wartet auf Genehmigung",
    shellExecuteHint: "Diesen Befehl ausführen?",
    shellReject: "Ablehnen",
    shellRun: "Ausführen",
    shellRunning: "Läuft",
    streaming: "Streamt",
    subagentDone: "Subagent erledigt",
    subagentDoneProgress: "Subagent erledigt ({pct}%)",
    subagentFailed: "Subagent fehlgeschlagen",
    subagentRunning: "Subagent läuft",
  },
  planBadge: {
    ...en.planBadge,
    blocked: "Blockiert",
    done: "Erledigt",
    failed: "Fehlgeschlagen",
    pending: "Ausstehend",
    running: "Läuft",
  },
  composer: {
    ...en.composer,
    atHeader: "Dateien erwähnen",
    close: "Schließen",
    commandPalette: "Befehlsübersicht",
    commands: "Befehle",
    commandsLabel: "Befehle",
    confirm: "Bestätigen",
    imageFilterName: "Bilder",
    insertFile: "Datei einfügen",
    insertImage: "Bild einfügen",
    interrupt: "Unterbrechen",
    mentionFiles: "Dateien erwähnen",
    mentionLabel: "Erwähnen",
    newline: "Neue Zeile",
    noMatches: "Keine Treffer",
    placeholder: "Prompt eingeben…",
    queue: "Warteschlange",
    queueCount: "{count} in Warteschlange",
    select: "Auswählen",
    send: "Senden",
    slashHeader: "Slash-Befehle",
    switchModel: "Modell wechseln",
    switchEffort: "Reasoning-Effort wechseln",
    workspaceRoot: "Arbeitsbereich-Root",
  },
  contextPanel: {
    ...en.contextPanel,
    allow: "Erlauben",
    ask: "Fragen",
    autoApproveTitle: "Auto-genehmigen",
    cacheKey: "Cache",
    contextTokens: "Kontext-Tokens",
    fileInContext: "Im Kontext",
    fileModified: "Geändert",
    filesCount: "{count} Dateien",
    filesTab: "Dateien",
    filesTitle: "Dateien",
    freeKey: "Frei",
    itemCount: "{count} Einträge",
    mcpConfigured: "Konfiguriert",
    mcpConnecting: "Verbinde…",
    mcpDisabled: "Deaktiviert",
    mcpEmpty: "Keine MCP-Server",
    mcpFailed: "Fehlgeschlagen",
    mcpReady: "Bereit",
    mcpReadyAll: "Alle bereit",
    mcpReadySome: "Teils bereit",
    mcpTitle: "MCP",
    mcpTools: "Tools",
    memoryTab: "Memory",
    memoryTitle: "Memory",
    noFilesMsg: "Keine Dateien im Kontext",
    noMemoriesMsg: "Keine Erinnerungen",
    reservedKey: "Reserviert",
    ruleReadOnly: "Schreibgeschützt",
    ruleReview: "Überprüfung",
    ruleShellAllowlist: "Shell-Allowlist",
    rulesTab: "Regeln",
    ruleWritesAsk: "Schreiben fragen",
    ruleYolo: "YOLO",
    scopeGlobal: "Global",
    scopeProject: "Projekt",
    toolsTab: "Tools",
    usedKey: "Verwendet",
  },
  dragDrop: {
    ...en.dragDrop,
    overlay: "Dateien hier ablegen",
  },
  extraCards: {
    ...en.extraCards,
    approve: "Genehmigen",
    balance: "Guthaben",
    cache: "Cache",
    cacheHit: "Cache-Treffer",
    contextWindow: "Kontextfenster",
    doctorTitle: "Diagnose",
    output: "Ausgabe",
    prompt: "Prompt",
    reasoning: "Reasoning",
    reject: "Ablehnen",
    sessionCost: "Sitzungskosten",
    sessionUsage: "Sitzungsnutzung",
    topToolsUsage: "Top-Tools",
    unknownKind: "Unbekannt",
    memoryUser: "Benutzer",
    memoryFeedback: "Feedback",
    memoryProject: "Projekt",
    memoryReference: "Referenz",
  },
  jobs: {
    ...en.jobs,
    empty: "Keine Hintergrund-Jobs",
    exited: "Beendet",
    kbClose: "Schließen",
    kbToggle: "Umschalten",
    running: "Läuft",
    stop: "Stopp",
    stopAll: "Alle stoppen",
    stopAllTip: "Alle Jobs stoppen",
    stopOne: "Stopp",
    title: "Hintergrund-Jobs",
  },
  live: {
    ...en.live,
    deliveredWaiting: "Warte auf nächste Nachricht",
    reasoning: "Reasoning",
    running: "Läuft",
    secondsAgo: "vor {n}s",
    you: "Du",
  },
  markdown: {
    ...en.markdown,
    copied: "Kopiert!",
    copy: "Kopieren",
    externalLinkTitle: "In neuem Tab öffnen",
    filePillTitle: "Datei öffnen",
    localLinkTitle: "Link öffnen",
  },
  palette: {
    ...en.palette,
    abort: "Abbrechen",
    abortHint: "Aktuelle Anfrage abbrechen",
    about: "Über",
    clearChat: "Chat leeren",
    clearChatHint: "Unterhaltung leeren",
    closeTab: "Tab schließen",
    closeTabHint: "Aktuellen Tab schließen",
    copyConv: "Unterhaltung kopieren",
    copyConvHint: "Unterhaltung als Markdown kopieren",
    copyLast: "Letzte Antwort kopieren",
    copyLastHint: "Letzte Assistentennachricht kopieren",
    countSuffix: "Einträge",
    empty: "Keine passenden Befehle",
    exportMd: "Als Markdown exportieren",
    exportMdHint: "Chat als Markdown-Datei exportieren",
    focusComposer: "Composer fokussieren",
    footClose: "Schließen",
    footMove: "Bewegen",
    footRun: "Ausführen",
    groupAction: "Aktionen",
    groupNav: "Navigation",
    groupSettings: "Einstellungen",
    groupWorkspace: "Arbeitsbereich",
    newChat: "Neuer Chat",
    newChatHint: "Neues Gespräch beginnen",
    newTab: "Neuer Tab",
    newTabHint: "Neuen Tab öffnen",
    pickWorkspace: "Arbeitsbereich wechseln",
    pickWorkspaceHint: "Arbeitsbereich ändern",
    searchPlaceholder: "Befehle suchen…",
    settings: "Einstellungen",
    settingsHint: "Einstellungen öffnen",
  },
  panel: {
    ...en.panel,
    renderError: "Panel abgestürzt",
  },
  sidebarPanel: {
    ...en.sidebarPanel,
    approvalRules: "Genehmigungsregeln",
    cancel: "Abbrechen",
    commandPalette: "Befehlsübersicht",
    daysAgo: "vor {n}T",
    delete: "Löschen",
    deleteSession: "Sitzung löschen",
    hoursAgo: "vor {n}h",
    justNow: "Gerade eben",
    loading: "Lade…",
    messageCount: "{count} Nachrichten",
    minutesAgo: "vor {n}m",
    newChat: "Neuer Chat",
    noMatches: "Keine Treffer",
    noSessions: "Keine Sitzungen",
    recent: "Letzte",
    searchSessions: "Sitzungen durchsuchen…",
    sessionTitle: "Sitzungen",
    settings: "Einstellungen",
    weeksAgo: "vor {n}W",
  },
  statusbar: {
    ...en.statusbar,
    balance: "Guthaben",
    busy: "Beschäftigt",
    cache: "Cache",
    cacheHit: "Cache-Treffer",
    jobs: "Jobs",
    jobsTip: "Hintergrund-Jobs",
    offline: "Offline",
    online: "Online",
    switchCurrency: "Währung wechseln",
    switchTheme: "Theme wechseln",
    switchWorkspace: "Arbeitsbereich wechseln",
    themeDark: "Dunkel",
    themeLight: "Hell",
    themeStyleGraphite: "Graphit",
    themeStyleSandstone: "Sandstein",
    themeStylePorcelain: "Porzellan",
    themeStyleMidnight: "Mitternacht",
    thisTurn: "Dieser Turn",
    tokens: "Tokens",
  },
  thread: {
    ...en.thread,
    activePlan: "Aktiver Plan",
    allowRead: "Lesen erlauben",
    allowWrite: "Schreiben erlauben",
    alwaysAllow: "Immer erlauben",
    alwaysAllowPrefix: "{prefix} immer erlauben",
    approve: "Genehmigen",
    approveRewrite: "Neuschreibung genehmigen",
    cancel: "Abbrechen",
    checkpointKind: "Checkpoint",
    checkpointSub: "Aktuellen Zustand speichern",
    checkpointTitle: "Checkpoint erstellen",
    collapse: "Einklappen",
    continue: "Fortsetzen",
    copyMessage: "Nachricht kopieren",
    copyResponse: "Antwort kopieren",
    execute: "Ausführen",
    keepOriginal: "Original behalten",
    keepSteps: "Schritte behalten",
    optionCount: "{count} Optionen",
    pathAccessKind: "Pfadzugriff",
    planConfirmationKind: "Plan-Genehmigung",
    planRevisionKind: "Plan-Überarbeitung",
    planRunning: "Plan in Bearbeitung",
    planStepCount: "Schritt {done}/{total}",
    readPathOutsideSandbox: "Pfad außerhalb des Sandbox lesen",
    refine: "Verfeinern",
    reject: "Ablehnen",
    revise: "Überarbeiten",
    revisionMeta: "Überarbeitung",
    rewritePlan: "Plan umschreiben",
    risk: "Risikobewertung",
    riskMedium: "Mittleres Risiko",
    runBackgroundCommand: "Im Hintergrund ausführen",
    runCommand: "Befehl ausführen",
    shellConfirmationKind: "Shell-Bestätigung",
    startPlan: "Plan starten",
    stop: "Stopp",
    subagent: "Subagent",
    userChoiceKind: "Benutzerauswahl",
    writePathOutsideSandbox: "Pfad außerhalb des Sandbox schreiben",
    you: "Du",
  },
  workdir: {
    ...en.workdir,
    browse: "Durchsuchen…",
    cancel: "Abbrechen",
    empty: "Keine Arbeitsbereiche",
    emptyDir: "Keine Unterverzeichnisse.",
    go: "Gehe zu",
    goTip: "Zu diesem Pfad navigieren",
    loading: "Lade…",
    openHere: "Diesen Ordner öffnen",
    pathPlaceholder: "Absoluter Pfad…",
    promptWeb: "Absoluten Pfad des zu öffnenden Arbeitsbereichs eingeben:",
    searchPlaceholder: "Arbeitsbereiche durchsuchen…",
    title: "Arbeitsbereich",
  },
  about: {
    ...en.about,
    close: "Schließen",
    repo: "Repository",
    sidebarLabel: "Über",
    tagline: "KI-gestützter Coding-Assistent",
    version: "Version",
  },
  effort: {
    ...en.effort,
    lowDesc: "am schnellsten — minimales Reasoning",
    mediumDesc: "ausgewogen",
    highDesc: "Standard — sicher für vLLM / Azure",
    maxDesc: "DeepSeek-Erweiterung; von stock OpenAI / vLLM abgelehnt",
  },
  editMode: {
    ...en.editMode,
    plan: "Plan",
    planHint: "schreibgeschützt · alle Schreibwerkzeuge verweigern die Ausführung",
    review: "Überprüfen",
    reviewHint: "sowohl Edits als auch nicht-allowlistete Shell fragen zuerst",
    auto: "Auto",
    autoHint: "Edits auto-anwenden, Shell fragt weiterhin",
    yolo: "YOLO",
    yoloHint: "Edits UND Shell auto-ausführen, Allowlist umgangen",
  },
};
